import type { ChunkEntry, RuntimeShim } from './types';
import { attachWebpackHelpers } from './webpack-helpers';
import { matchHostModule, detectAndSwapReactModule } from './module-resolution';

export const createRuntimeShim = (
  chunkBaseUrl: string,
  chunkMap: Record<string, string> = {},
): RuntimeShim => {
  const moduleFactories: Record<string, Function> = {};
  const moduleCache: Record<string, Record<string, unknown>> = {};
  const loadedChunks: Record<string, 0 | Promise<void> | undefined> = {};
  const hostModules: Record<string, unknown> = {};

  const webpackRequire: Record<string, unknown> &
    ((id: string | number) => unknown) = ((rawId: string | number) => {
    const moduleId = String(rawId);

    if (moduleCache[moduleId]) {
      return moduleCache[moduleId].exports;
    }

    const hostMatch = matchHostModule(moduleId, hostModules);
    if (hostMatch) return hostMatch;

    if (!moduleFactories[moduleId]) {
      throw new Error(`[MF-shim] Module "${moduleId}" not found`);
    }

    const mod: Record<string, unknown> = {
      exports: {},
      hot: {
        accept: () => {},
        dispose: () => {},
        invalidate: () => {},
        data: {},
      },
    };
    moduleCache[moduleId] = mod;
    moduleFactories[moduleId](mod, mod.exports, webpackRequire);

    detectAndSwapReactModule(mod, hostModules);

    return mod.exports;
  }) as Record<string, unknown> & ((id: string | number) => unknown);

  attachWebpackHelpers(webpackRequire, loadedChunks, chunkBaseUrl, chunkMap);

  const processChunk = (chunk: ChunkEntry) => {
    const [chunkIds, factories, runtimeCallback] = chunk;

    const hasMap = Object.keys(chunkMap).length > 0;
    if (hasMap && chunkIds && chunkIds.length > 0) {
      const ownsAny = chunkIds.some(id => chunkMap[String(id)] !== undefined);
      if (!ownsAny) return;
    }

    if (chunkIds) {
      for (const id of chunkIds) {
        loadedChunks[String(id)] = 0;
      }
    }

    if (factories) {
      for (const id in factories) {
        if (Object.hasOwn(factories, id)) {
          moduleFactories[id] = factories[id];
        }
      }
    }

    if (runtimeCallback) {
      runtimeCallback(webpackRequire);
    }
  };

  return {
    processChunk,
    setSharedModules(shared: Record<string, unknown>) {
      Object.assign(hostModules, shared);
    },
  };
};
